/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Order_Confirm_ErrorInputs */

const vi_toast_order_confirm_error = /** @type {(inputs: Toast_Order_Confirm_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận đơn hàng thất bại`)
};

/**

* @param {Toast_Order_Confirm_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_order_confirm_error = /** @type {((inputs?: Toast_Order_Confirm_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Order_Confirm_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_order_confirm_error(inputs)
});